import { Toast } from 'vant'

export function ShowToast() {
  Toast.loading({
    duration: 0,
    message: '数据加载中...',
    forbidClick: true
  })
}

export function CloseToast() {
  Toast.clear()
}

export function CloseToastMsg(msg) {
  Toast.clear()
  Toast.fail(msg)
}

export function ToastMsg(msg) {
  Toast(msg)
}



// WEBPACK FOOTER //
// ./src/api/common/toast.js